import { render, staticRenderFns } from "./FormCascaderItem.vue?vue&type=template&id=671779b7&"
import script from "./FormCascaderItem.vue?vue&type=script&lang=js&"
export * from "./FormCascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./FormCascaderItem.vue?vue&type=style&index=0&id=671779b7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports